import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../../config/firebaseConfig';

// Kategoriler kayda Türkçe yazılır; ekranda anahtarla çevrilir
export const EXPENSE_CATEGORIES = [
  { value: 'Ulaşım', key: 'transport' },
  { value: 'Yemek', key: 'food' },
  { value: 'Konaklama', key: 'accommodation' },
  { value: 'Malzeme', key: 'supplies' },
  { value: 'Eğitim', key: 'training' },
  { value: 'Diğer', key: 'other' },
];

export const DEFAULT_EXPENSE_CATEGORY = 'Diğer';

export const MAX_PDF_BYTES = 10 * 1024 * 1024;

export const EXPENSE_STATUS_TONES = { pending: 'warning', approved: 'success', rejected: 'danger' };

/** Category name in the UI language (unknown values as stored). */
export const expenseCategoryLabel = (t, value) => {
  const category = EXPENSE_CATEGORIES.find((item) => item.value === value);
  return category ? t(`profilePage.expense.categories.${category.key}`) : (value || t('profilePage.expense.categories.other'));
};

/** Accepted PDFs of a selection (only PDF, at most 10 MB each); rejects are reported. */
export const pickPdfFiles = (fileList, onReject) => Array.from(fileList).filter((file) => {
  if (file.type !== 'application/pdf') {
    onReject('notPdf', file);
    return false;
  }
  if (file.size > MAX_PDF_BYTES) {
    onReject('tooLarge', file);
    return false;
  }
  return true;
});

/** Attached PDFs of a request: `pdfUrls` (new) or a single `pdfUrl` (old records). */
export const attachedPdfs = (request) => {
  if (Array.isArray(request?.pdfUrls) && request.pdfUrls.length > 0) {
    return request.pdfUrls.map((url, index) => ({ url, name: request.pdfFileNames?.[index] || null }));
  }
  if (request?.pdfUrl) return [{ url: request.pdfUrl, name: request.pdfFileName || null }];
  return [];
};

/** The user's expense requests, live, newest first. */
export const useMyExpenseRequests = (employeeId, active) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!employeeId || !active) return undefined;
    setLoading(true);
    const q = query(collection(db, 'ExpenseRequests'), where('employeeId', '==', employeeId));
    return onSnapshot(q, (snapshot) => {
      const results = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      results.sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''));
      setRequests(results);
      setLoading(false);
    }, (err) => {
      console.error('Masraf talepleri yüklenemedi:', err);
      setLoading(false);
    });
  }, [employeeId, active]);

  return { requests, setRequests, loading };
};
